<p>template-editor-dialog works!</p>
